<div style="padding-top:2px;margin:15px" *ngFor="let played of config.holes_played_per_round; let offset_index = index">
    <div class="row">{{eventResult.round_name.split(',')[offset_index]}}</div>
    <div class="row">
        <div fxLayout='row' fxLayout.xs='column'>
            <table class="score-summary">
                <tr style="background-color:silver!important">
                    <td *ngFor="let x of holesIndex">
                        {{eventInfo.pars[$index]}}
                    </td>
                    <td>F</td>
                </tr>
                <tr>
                    <td *ngFor="let x of holesIndex; let i = index" ng-class="getScoreClass(eventResult.holes_net[i+offset_index*played],eventInfo.pars[i])">
                        {{eventResult.holes_net[i+offset_index*played]}}
                    </td>
                    <td style="font-size:10px!important">
                        {{sum(eventResult.holes_net,0+offset_index*played,9+offset_index*played)}}
                    </td>
                </tr>
            </table>
            <table class="score-summary">
                <tr style="background-color:silver!important">
                    <td *ngFor="let x of holesIndex; let i = index">
                        {{eventInfo.pars[i+9]}}
                    </td>
                    <td>B</td>
                </tr>
                <tr>
                    <td *ngFor="let x of holesIndex; let i = index" ng-class="getScoreClass(eventResult.holes_net[i+9+offset_index*played],eventInfo.pars[i+9])">
                        {{eventResult.holes_net[i+9+offset_index*played]}}
                    </td>
                    <td style="font-size:10px!important">
                        {{sum(eventResult.holes_net,9+offset_index*played,18+offset_index*played)}}
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>